import React, {useState, useEffect} from 'react';
import {Controller, useForm} from 'react-hook-form';

import {
  Button,
  CircularProgress,
  TextField,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  Input,
  ClickAwayListener,
  IconButton,
  InputBase,
} from '@material-ui/core';
// Icon
import Icon from '@mdi/react';

import {Formik} from 'formik';
import {
  MuiPickersUtilsProvider,
  DatePicker,
  DateTimePicker,
  TimePicker,
} from '@material-ui/pickers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';
import {
  translateOrderStatus,
  convertPersianDigit2English,
  translateBundleStatus,
  translateUserRoles,
  checkMatchMedia,
  translateCenterStatus,
  OrderTransportationType,
  translateParcelsStatus,
  translateFleetStatus,
  translateVehicleType,
  translateTransactionType,
  translateOrderTransportationType,
  translateOrderBundleStatus,
  translateDriversEmploymentStatus,
  translateFleetType,
  removeEmptyValueObject,
  // removeEmptyValueObject,
  // flattenObject,
} from './helpers';
import {Status as OrderStatus} from '../pages/orders/interfaces';
import {
  OrderBundleStatus,
  Status as BundleStatus,
} from '../pages/bundles/interfaces';
import {Status as CenterStatus} from '../pages/centers/interfaces';
import {UserRole} from '../pages/users/interfaces';
import {Status as ParcelsState} from '../pages/parcels/interfaces';
import {Category} from '../pages/products/interfaces';
import {mdiClose} from '@mdi/js';
import clsx from 'clsx';
import {mdiMagnify} from '@mdi/js/commonjs/mdi';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {flattenObject} from 'client-sdk/src/helpers';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

export type State = {
  classes: Function;
};
export type Props = {
  filters: Filter[];
  onFilter: any; //ToDo
  baseFilter: BaseFilter;
  filterValues: any;
  mainFiltersCount: number;
};

export type BaseFilter = {
  type:
    | 'input'
    | 'select'
    | 'checkbox'
    | 'date-picker'
    | 'number'
    | 'time-picker'
    | 'date-picker-time';
  id: string;
  placeholder: string;
};

export type Filter = {
  type:
    | 'input'
    | 'select'
    | 'checkbox'
    | 'date-picker'
    | 'number'
    | 'time-picker'
    | 'date-picker-time';
  id: string;
  label: string;
  placeholder?: string;
  data?:
    | OrderStatus[]
    | BundleStatus[]
    | UserRole[]
    | CenterStatus[]
    | ParcelsState[]
    | OrderTransportationType[]
    | OrderBundleStatus[]
    | Category[];
  translateType?:
    | 'Order'
    | 'Category'
    | 'Bundle'
    | 'UserRole'
    | 'CenterStatus'
    | 'ParcelsStatus'
    | 'FleetType'
    | 'EmploymentStatus'
    | 'VehicleType'
    | 'TransactionType'
    | 'TPL'
    | 'OrderBundleStatus'
    | 'FleetStatus';
  icon?: any;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
      '& .MuiSelect-root': {
        fontSize: '1rem !important',
      },
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    closeIcon: {
      color: '#EC4040',
      backgroundColor: '#F7B3B3',
      borderRadius: '5px',
      padding: '5px',
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    textInput: {
      color: '#8a8a8a',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    inputWrapper: {
      flex: 7,
    },
    icon: {
      color: '#8a8a8a',
    },
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function RenderFilters(props: Props) {
  const [checkboxValue, setCheckboxValue] = useState([] as any[]);
  const classes = useStyles();
  const [init, setInit] = useState({} as any);
  const {filters, onFilter, baseFilter, filterValues, mainFiltersCount} = props;
  const [openFilterBox, setOpenFilterBox] = React.useState(false);

  const {register, handleSubmit, control, setValue, getValues, watch, reset} =
    useForm<any>();

  useEffect(() => {
    props.filters?.map((item: any) => {
      if (item.type === 'date-picker-time' || item.type === 'date-picker') {
        register({name: item.id}, {required: false});
      }
    });
  }, [register]);

  useEffect(() => {
    props.filters?.map((item: any) => {
      setValue(item.id, filterValues[item.id]);
    });
  }, [openFilterBox]);

  // const handleSubmit = (e: React.FormEvent<HTMLInputElement>) => {
  //   e.preventDefault();
  // };
  const handleChange = (event: any) => {
    setCheckboxValue(event.target.value);
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
        'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const renderFromItems = (filters: Record<string, any>[], props: any) => {
    const values = flattenObject(getValues());
    return filters.map(
      (
        item: any, //todo type
        index: number
      ) => (
        <Grid
          className={classes.root}
          container
          item
          spacing={2}
          xs={12}
          sm={6}
          key={index}
        >
          {(item.type === 'input' ||
            item.type === 'number' ||
            item.type === 'date-picker' ||
            'date-picker-time' ||
            item.type === 'checkbox' ||
            (item.type === 'select' && item.icon)) &&
            item.icon && (
              <Grid
                item
                style={{
                  display: 'flex',
                  flex: 1,
                  alignItems: 'center',
                  marginTop: '10px',
                }}
              >
                <Icon path={item.icon} size={1} className={classes.icon} />
              </Grid>
            )}
          {item.type === 'input' && (
            <Grid item className={classes.inputWrapper}>
              <TextField
                inputRef={register({required: false})}
                name={item.id}
                label={item.label}
                className={classes.textInput}
                fullWidth
                defaultValue={null}
              />
            </Grid>
          )}

          {item.type === 'number' && (
            <Grid item className={classes.inputWrapper}>
              <TextField
                inputRef={register({required: false})}
                name={item.id}
                label={item.label}
                type={item.type}
                className={classes.textInput}
                fullWidth
                defaultValue={null}
              />
            </Grid>
          )}

          {item.type === 'date-picker' && (
            <Grid item className={classes.inputWrapper}>
              <Controller
                style={{width: '100%'}}
                name={item.id}
                control={control}
                rules={{required: false}}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DatePicker
                      inputRef={register({required: false})}
                      fullWidth
                      autoOk
                      variant="inline"
                      label={item.label}
                      className={classes.textInput}
                      format="YYYY/MM/DD"
                      clearable
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      clearLabel="پاک کردن"
                      labelFunc={date =>
                        date?.isValid() ? date.format('jYYYY/jMM/jDD') : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value &&
                            convertPersianDigit2English(
                              value.format('YYYY-MM-DD')
                            )
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}

          {item.type === 'time-picker' && (
            <Grid item className={classes.inputWrapper}>
              <Controller
                style={{width: '100%'}}
                name={item.id}
                control={control}
                rules={{required: false}}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <TimePicker
                      fullWidth
                      label={item.label}
                      variant="inline"
                      ampm={false}
                      format="HH:mm"
                      className={classes.textInput}
                      autoOk
                      clearable
                      labelFunc={date =>
                        date?.isValid() ? date.format('HH:mm') : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value &&
                            convertPersianDigit2English(
                              value.format('jYYYY/jMM/jDD HH:mm')
                            )
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}

          {item.type === 'date-picker-time' && (
            <Grid item className={classes.inputWrapper}>
              <Controller
                style={{width: '100%'}}
                name={item.id}
                control={control}
                rules={{required: false}}
                render={() => (
                  <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                    <DateTimePicker
                      inputRef={register({required: false})}
                      fullWidth
                      label={item.label}
                      variant="inline"
                      format="YYYY/MM/DD HH:mm"
                      autoOk
                      className={classes.textInput}
                      clearable
                      okLabel="تأیید"
                      cancelLabel="لغو"
                      clearLabel="پاک کردن"
                      labelFunc={date =>
                        date?.isValid()
                          ? date.format('jYYYY/jMM/jDD HH:mm')
                          : ''
                      }
                      value={watch(`${item.id}`) || null}
                      name={item.id}
                      id={item.id}
                      onChange={value => {
                        return setValue(
                          item.id,
                          value && convertPersianDigit2English(value.format())
                        );
                      }}
                    />
                  </MuiPickersUtilsProvider>
                )}
              />
            </Grid>
          )}
          {item.type === 'select' && (
            <Grid item className={classes.inputWrapper}>
              <FormControl style={{width: '100%'}}>
                <InputLabel htmlFor={item.id}>{item.label}</InputLabel>
                <Controller
                  name={item.id}
                  control={control}
                  rules={{required: false}}
                  render={({onChange, value}) => (
                    <Select
                      inputRef={register({required: false})}
                      fullWidth
                      name={item.id}
                      className={classes.textInput}
                      onChange={e => {
                        setValue(item.id, e.target.value);
                      }}
                      value={values[item.id] || ''}
                      inputProps={{
                        name: item.id,
                        id: item.id,
                      }}
                    >
                      <MenuItem aria-label="None" value="" />
                      {item.data.map((itemD: any, index: number) => (
                        <MenuItem value={itemD} key={index}>
                          {item.translateType === 'Order'
                            ? translateOrderStatus(itemD)
                            : item.translateType === 'UserRole'
                            ? translateUserRoles(itemD)
                            : item.translateType === 'ParcelsStatus'
                            ? translateParcelsStatus(itemD)
                            : item.translateType === 'FleetStatus'
                            ? translateFleetStatus(itemD)
                            : item.translateType === 'VehicleType'
                            ? translateVehicleType(itemD)
                            : item.translateType === 'TransactionType'
                            ? translateTransactionType(itemD)
                            : item.translateType === 'TPL'
                            ? translateOrderTransportationType(itemD)
                            : item.translateType === 'OrderBundleStatus'
                            ? translateOrderBundleStatus(itemD)
                            : item.translateType === 'EmploymentStatus'
                            ? translateDriversEmploymentStatus(itemD)
                            : translateBundleStatus(itemD)}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
          )}
          {item.type === 'checkbox' && (
            <Grid item className={classes.inputWrapper}>
              <FormControl style={{width: '100%'}}>
                <InputLabel id={item.id}>{item.label}</InputLabel>
                <Controller
                  name={item.id}
                  control={control}
                  rules={{required: false}}
                  render={({onChange, value}) => (
                    <Select
                      inputRef={register({required: false})}
                      labelId={item.id}
                      id={item.id}
                      multiple
                      className={classes.textInput}
                      onChange={e => {
                        handleChange(e);
                        setValue(item.id, e.target.value);
                      }}
                      value={values[item.id]?.split(',') || []}
                      input={<Input />}
                      name={item.id}
                      inputProps={{
                        name: item.id,
                        id: item.id,
                      }}
                      renderValue={(selected: any) => {
                        const nameSelectedItem = item.data.filter(
                          (status: any) => {
                            return selected.includes(status);
                          }
                        );

                        return nameSelectedItem
                          .map((nameSelect: any) =>
                            item.translateType === 'Order'
                              ? translateOrderStatus(nameSelect)
                              : item.translateType === 'UserRole'
                              ? translateUserRoles(nameSelect)
                              : item.translateType === 'Category'
                              ? nameSelect
                              : item.translateType === 'CenterStatus'
                              ? translateCenterStatus(nameSelect)
                              : item.translateType === 'ParcelsStatus'
                              ? translateParcelsStatus(nameSelect)
                              : item.translateType === 'TPL'
                              ? translateOrderTransportationType(nameSelect)
                              : item.translateType === 'OrderBundleStatus'
                              ? translateOrderBundleStatus(nameSelect)
                              : item.translateType === 'FleetType'
                              ? translateFleetType(nameSelect)
                              : translateBundleStatus(nameSelect)
                          )
                          .join(',');
                      }}
                      MenuProps={MenuProps}
                    >
                      {item.data.map((itemD: any) => (
                        <MenuItem key={itemD} value={itemD}>
                          <Checkbox
                            checked={
                              checkboxValue.indexOf(itemD) > -1 ||
                              values[item.id]?.indexOf(itemD) > -1
                            }
                          />
                          <ListItemText
                            primary={
                              // Todo
                              item.translateType === 'Order'
                                ? translateOrderStatus(itemD)
                                : item.translateType === 'UserRole'
                                ? translateUserRoles(itemD)
                                : item.translateType === 'Category'
                                ? itemD
                                : item.translateType === 'CenterStatus'
                                ? translateCenterStatus(itemD)
                                : item.translateType === 'ParcelsStatus'
                                ? translateParcelsStatus(itemD)
                                : item.translateType === 'TPL'
                                ? translateOrderTransportationType(itemD)
                                : item.translateType === 'OrderBundleStatus'
                                ? translateOrderBundleStatus(itemD)
                                : item.translateType === 'FleetType'
                                ? translateFleetType(itemD)
                                : translateBundleStatus(itemD)
                            }
                          />
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
            </Grid>
          )}
        </Grid>
      )
    );
  };

  const clearForm = (props?: any) => {
    setCheckboxValue([]);
    props.onFilter({});
  };

  const renderInitialValues = (items: Filter[]) => {
    const initialValues: any = {};
    items.map((filter: Filter) => (initialValues[filter.id] = null));
    setInit(initialValues);
  };

  const onSubmit = (data: any) => {
    props.onFilter(data);
    setOpenFilterBox(false);
  };

  return (
    <div style={{width:'90%'}} >
      <Grid item xs={12} >
        <div className={classes.searchBox}>
          <Grid
            container
            style={{flexGrow: 2, maxWidth: '100%', margin: 0}}
            item
            spacing={1}
            xs={12}
            sm={6}
          >
            <form style={{width: '100%'}} onSubmit={handleSubmit(onSubmit)}>
              <Grid
                style={{marginRight: 0, marginLeft: 0}}
                container
                item
                spacing={1}
                alignItems={'center'}
                xs={12}
              >
                <Grid item>
                  <IconButton
                    type="submit"
                    className={classes.iconButton}
                    aria-label="search"
                  >
                    <Icon
                      path={mdiMagnify}
                      size={1}
                      className={classes.magnifyIcon}
                    />
                  </IconButton>
                </Grid>
                {baseFilter.type === 'input' && (
                  <Grid item style={{flexGrow: 2}}>
                    <InputBase
                      inputRef={register({required: false})}
                      name={baseFilter.id}
                      placeholder={baseFilter.placeholder}
                      fullWidth
                      defaultValue={null}
                    />
                  </Grid>
                )}

                {baseFilter.type === 'number' && (
                  <Grid item style={{flexGrow: 2}}>
                    <InputBase
                      inputRef={register({required: false})}
                      name={baseFilter.id}
                      placeholder={baseFilter.placeholder}
                      type={baseFilter.type}
                      fullWidth
                    />
                  </Grid>
                )}
              </Grid>
            </form>
          </Grid>
          {
            filters&&(
              <ClickAwayListener onClickAway={handleClickAway}>
            <div>
              <Button
                type="button"
                onClick={handleClick}
                className={classes.iconButton}
                aria-label="search"
              >
                {openFilterBox ? 'بستن' : 'جستجوی پیشرفته'}
              </Button>
              {Object.keys(filterValues).length > 3 + mainFiltersCount && (
                <IconButton
                  className={classes.iconButton}
                  aria-label="cancelFilter"
                  onClick={() => {
                    onFilter({page: 0, size: 10});
                    reset({});
                  }}
                  title="پاک کردن فیلتر"
                >
                  <Icon
                    path={mdiClose}
                    size={1}
                    className={classes.closeIcon}
                  />
                </IconButton>
              )}
              {openFilterBox ? (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div
                    className={clsx(classes.filterBox, {
                      [classes.filterOpen]: openFilterBox,
                    })}
                  >
                    <Grid
                      container
                      spacing={checkMatchMedia('(max-width: 768px)') ? 1 : 3}
                    >
                      {renderFromItems(filters, props)}
                      <Grid
                        xs={12}
                        item
                        style={{
                          display: 'flex',
                          marginTop: '20px',
                          marginBottom: '20px',
                          marginRight: 'auto',
                        }}
                      >
                        <div style={{display: 'flex', flexGrow: 1}} />
                        <div style={{padding: '0 5px'}}>
                          <Button
                            fullWidth
                            style={{marginLeft: '50px'}}
                            variant="contained"
                            size="large"
                            type="button"
                            onClick={() => {
                              reset({});
                              onFilter({});
                              setCheckboxValue([]);
                            }}
                            disabled={
                              Object.keys(
                                flattenObject(removeEmptyValueObject(watch()))
                              ).length === 0
                            }
                          >
                            {'پاک‌ کردن فرم'}
                          </Button>
                        </div>
                        <div style={{padding: '0 5px'}}>
                          <Button
                            fullWidth
                            type="submit"
                            variant="contained"
                            color="secondary"
                            autoFocus
                            size="large"
                            data-cy="search"
                            disabled={
                              Object.keys(
                                flattenObject(removeEmptyValueObject(watch()))
                              ).length === 0
                            }
                          >
                            {'جستجو'}
                            {false && <CircularProgress size={24} />}
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </form>
              ) : null}
            </div>
          </ClickAwayListener>
            )
          }
        </div>
        {/* <Divider /> */}
      </Grid>
    </div>
  );
}

export default RenderFilters;
